The result for the `verifyCandidate` mutation when verification is expired.
